// Keep cached graves until explicitly invalidated or updated via websocket/mutation
const CACHE_TTL_MS = Infinity;
const cache = new Map();

const isValidGravePayload = (payload) => {
  if (!payload || typeof payload !== 'object') return false;
  if (Array.isArray(payload)) return false;
  return Boolean(payload.id || payload.slug || payload.grave_slug || payload.name);
};

const normalizeGravePayload = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  const unwrapped = payload.grave && typeof payload.grave === 'object' ? payload.grave : payload;
  if (!isValidGravePayload(unwrapped)) return null;
  return unwrapped;
};

export const getCachedGrave = (slug) => {
  if (!slug) return null;
  const entry = cache.get(slug);
  if (!entry) return null;
  const normalized = normalizeGravePayload(entry.data);
  if (!normalized) {
    // Drop invalid/empty cache entries so callers will refetch.
    cache.delete(slug);
    return null;
  }
  const normalizedSlug = normalized.slug || normalized.grave_slug;
  if (normalizedSlug && normalizedSlug !== slug) {
    // Cached payload does not belong to this slug; drop it to avoid stale data.
    cache.delete(slug);
    return null;
  }
  if (normalized !== entry.data) {
    cache.set(slug, { data: normalized, expiresAt: entry.expiresAt });
  }
  return normalized;
};

export const storeGraveInCache = (slug, data) => {
  if (!slug || !data) return;
  const normalized = normalizeGravePayload(data);
  if (!normalized) return;
  const normalizedSlug = normalized.slug || normalized.grave_slug || slug;
  if (normalizedSlug !== slug) {
    cache.delete(slug);
  }
  cache.set(normalizedSlug, { data: normalized, expiresAt: CACHE_TTL_MS });
};

export const clearGraveCache = () => {
  cache.clear();
};

export const invalidateGraveCache = (slug) => {
  if (slug) {
    cache.delete(slug);
    return;
  }
  cache.clear();
};
